// - fx/utils/resolveLimit.js
/**
 * resolveLimit — Convert a limit definition into an absolute viewport value.
 * --------------------------------------------------------------------------
 * Limit format:
 *   { from: "top" | "bottom", value: "40vh" | "120px", offset?: number }
 *
 * Returns:
 *   A pixel value representing the viewport threshold for animations/triggers.
 *
 * Used by:
 *   - FXEngine  (scroll → t mapping)
 *   - FXTrigger (enter/exit zones)
 *   - FXIO      (optional future enhancements)
 */
export function resolveLimit(limit) {

    if (!limit || !limit.from || !limit.value) {
        console.warn("resolveLimit: invalid limit", limit);
        return 0;
    }

    const { from, value, offset = 0 } = limit;

    const parsed = parseValueToPx(value);
    let result = 0;

    if (from === "top") {
        result = parsed;
    }

    else if (from === "bottom") {
        result = window.innerHeight - parsed;
    }

    else {
        console.warn("resolveLimit: unknown 'from' field:", from);
    }

    return result + offset;
}

/** Convert "20vh" / "200px" / number into px */
export function parseValueToPx(value) {

    if (typeof value === "number") return value;

    const str = String(value).trim().toLowerCase();
    const num = parseFloat(str);

    if (str.endsWith("vh")) return window.innerHeight * num / 100;
    if (str.endsWith("px")) return num;

    // fallback → assume pixels
    return num;

}